export function CmsPages() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-text">Website Pages</h1>
      <p className="text-text-muted">Manage website pages, content, and SEO settings here.</p>
    </div>
  )
}
